/**
 * @constant API_HOSTNAME
 * Replace with your Google AppScript Link
 */
export const API_HOSTNAME = `https://script.google.com/macros/s/AKfycbzk4ImJOK8t1EJqhufxFZL21PHPMgo_B-a3z3oHNuO1Sc659QbWkHgygZOyw9udT2wP_A/exec`;

const FIVE_MINS = 300000;
/**
 * @constant FOCUS_THROTTLE_INTERVAL
 * time used as SWR Focus throttle interval
 */
export const FOCUS_THROTTLE_INTERVAL = FIVE_MINS;

/**
 * @constant RSVP_STATUS
 * DO NOT CHANGES!
 */
export const RSVP_STATUS = {
  attend: 'ATTEND',
  notAttend: 'NOT_ATTEND',
  sent: 'SENT',
  opened: 'OPENED',
  waiting: 'WAITING',
};

/**
 * @constant ACTION_POST_TYPE
 * DO NOT CHANGES!
 */
export const ACTION_POST_TYPE = {
  insertGuest: 'insert_guest',
  insertWish: 'insert_wish',
  insertGiftConfirmation: 'insert_gift_confirmation',
  updateRsvp: 'update_rsvp',
};

/**
 * @constant ACTION_GET_TYPE
 * DO NOT CHANGES!
 */
export const ACTION_GET_TYPE = {
  read: 'read',
  readQrCode: 'read_qrcode',
};

/**
 * @constant API_TABLE_TYPE
 * DO NOT CHANGES!
 */
export const API_TABLE_TYPE = {
  wishes: 'WISHES',
  rsvp: 'RSVP',
  giftConfirmation: 'GIFT_CONFIRMATION',
};

export const API_ATTEND_INFO = [
  {
    title: 'Holy Matrimony',
    value: 'Holy Matrimony',
    shift: '1, 3',
  },
  {
    title: 'Reception',
    value: 'Reception',
    shift: '2, 3',
  },
  {
    title: 'Holy Matrimony and Reception',
    value: 'Holy Matrimony and Reception',
    shift: '3',
  },
];
